import { render } from "./CDSPrivacyPolicy.vue?vue&type=template&id=590014ee&ts=true"
import script from "./CDSPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./CDSPrivacyPolicy.vue?vue&type=script&lang=ts"

import "./CDSPrivacyPolicy.vue?vue&type=style&index=0&id=590014ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__